import { createBrowserRouter } from "react-router-dom";
import { Layout } from "../../_base/component/_layout/_layout";
import { LayoutAuth } from "../../_base/component/_layout/_layoutAuth";
import Dashboard from "../../views/Dashboard/Dashboard";
import _404 from "../../_base/component/_layout/_404";
import FlowStep from "../../views/Flow-step/FlowStep";
import HistoryView from "../../views/History/historyView";
import AdminSystemView from "../../views/Admin-system/AdminSystemView";
import SystemView from "../../views/System/SystemView";
import ProcessDefsView from "../../views/ProcessDefs/ProcessDefsView";
import PartnersView from "../../views/Partners/PartnersView";
import RolesView from "../../views/Roles/RolesView";
import OrganizationsView from "../../views/Organizations/OrganizationsView";
import UserView from "../../views/Users/UserView";
import ProcessInstancesTable from "../../views/History/ProcessInstancesTable";
import ForderTable from "../../views/History/ForderTable";
import SystemTable from "../../views/History/SystemTable";
import TaskTable from "../../views/History/TaskTable";
import EmailTemplate from "../../views/Admin-system/EmailTemplate";
import DesignTable from "../../views/Admin-system/DesignTable";
import FiletTable from "../../views/System/FiletTable";
import FlowTaskTable from "../../views/System/FlowTaskTable";
import ProcessTaskTable from "../../views/System/ProcessTaskTable";
import TypeContractTable from "../../views/System/TypeContractTable";
import ProcessDefsTable from "../../views/ProcessDefs/ProcessDefsTable";
import TemplateTable from "../../views/ProcessDefs/TemplateTable";
import FoldersTable from "../../views/Func/FoldersTable";
import ApproveTable from "../../views/Func/ApproveTable";
import UserTable from "../../views/Users/UserTable";
import OrganizationsTable from "../../views/Organizations/OrganizationsTable";
import RolesTable from "../../views/Roles/RolesTable";
import PartnersTable from "../../views/Partners/PartnersTable";

import { Layout1 } from "../../_base/component/_layout/_layout1";
import MainComponent from "../../views/Main/MainComponent";

import LayoutLogin from "../../_base/component/_login/_LayoutLogin";
import ListAccessSign from "../../views/Flow-step/ListAccessSign";
import SignTopage from "../../views/Flow-step/SignTopage";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { CreateProfile } from "../../views/Func/CreateProfile/CreateProfile";
import { EditProfile } from "../../views/Func/CreateProfile/EditProfile/EditProfile";
import ProFileView from "../../views/ProFile/ProfileView";
import { LayoutAnonymus } from "../../_base/component/_layout/_layoutAnonymus";
import SignTopageAnonymous from "../../views/Anonymous/SignTopageAnonymous";
import FlowStepExample from "../../views/Flow-step/FlowStepExample";
import FlowStep2 from "../../views/Flow-step/FlowStep2";
import Forgetlogin from "../../_base/component/_layout/_forgetLogin/_LayoutLogin";
import FlowStepExampleV2 from "../../views/Flow-step/FlowStepExampleV2";
import FlowStepExampleV2Edit from "../../views/Flow-step/FlowStepExampleV2Edit";
import PagePersion from "../../_base/component/_layout/_403";
import { DetailsProfile } from "../../views/Func/CreateProfile/EditProfile/DetailsProfile";
import ViewTopage from "../../views/Flow-step/ViewTopage";
import FoldersTableOld from "../../views/Func/FoldersTableOld";
import ListAccessSignForMe from "../../views/Flow-step/ListAccessSignForMe";

const router = createBrowserRouter(
  [
    {
      path: "/",
      id: "root",
      element: <Layout1 />,
      errorElement: <_404 />,
      action: async ({ request }) => {
        // if (auth)
        //  return protectedLoader;
      },
      children: [
        {
          path: "/", // Root path
          element: <Dashboard />,
        },
        {
          path: "/dashboard",
          element: <Dashboard />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Thông số thống kê";
              model.value = "/dashboard";
              return model;
            },
          },
        },
        {
          path: "/flow-step",
          element: <FlowStep />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Quy trình công việc";
              model.value = "/flow-step";
              return model;
            },
          },
        },
        {
          path: "/profile",
          element: <ProFileView />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Thôn tin cá nhân";
              model.value = "/profile";
              return model;
            },
          },
        },
        {
          path: "/history",
          //   element: <HistoryView />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Lịch sử";
              model.value = "/history";
              return model;
            },
          },
          children: [
            {
              path: "/history/process-instances",
              element: <ProcessInstancesTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Trình ký";
                  model.value = "history/process-instances";
                  return model;
                },
              },
            },
            {
              path: "/history/file",
              element: <ForderTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Hồ sơ";
                  model.value = "history/file";
                  return model;
                },
              },
            },
            {
              path: "/history/task",
              element: <TaskTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Phê duyệt";
                  model.value = "history/task";
                  return model;
                },
              },
            },
            {
              path: "/history/system",
              element: <SystemTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Hệ thống";
                  model.value = "history/system";
                  return model;
                },
              },
            },
          ],
        },
        {
          path: "/admin",
          //   element: <HistoryView />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Admin";
              model.value = "/admin";
              return model;
            },
          },
          children: [
            {
              path: "/admin/email-model",
              element: <EmailTemplate />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Mẫu Email";
                  model.value = "admin/email-model";
                  return model;
                },
              },
            },
            {
              path: "/admin/design",
              element: <DesignTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Giao diện";
                  model.value = "admin/design";
                  return model;
                },
              },
            },
          ],
        },
        {
          path: "/system",
          //   element: <SystemView />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Hệ thống";
              model.value = "/system";
              return model;
            },
          },
          children: [
            {
              path: "/system/process-task",
              element: <ProcessTaskTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Công việc đang xử lý";
                  model.value = "system/process-task";
                  return model;
                },
              },
            },
            {
              path: "/system/process-instances",
              element: <ProcessInstancesTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Quá trình duyệt";
                  model.value = "system/process-instances";
                  return model;
                },
              },
            },
            {
              path: "/system/document-type",
              element: <TypeContractTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Loại tài liệu";
                  model.value = "system/document-type";
                  return model;
                },
              },
            },
            // tạm ẩn vì hiển thị theo seq của oracle
            // {
            //   path: "/system/file-number",
            //   element: <FiletTable />,
            //   handle: {
            //     crumb: () => {
            //       let model: SelectListItem = {
            //         disabled: false,
            //         group: null,
            //         selected: false,
            //         text: "",
            //         value: "",
            //       };
            //       model.text = "Số hồ sơ";
            //       model.value = "system/file-number";
            //       return model;
            //     },
            //   },
            // },
          ],
        },
        {
          path: "/process-defs",
          // element: <ProcessDefsView />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Quy trình";
              model.value = "/process-defs";
              return model;
            },
          },
          children: [
            {
              path: "/process-defs/flow-model",
              element: <ProcessDefsTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Quy trình mẫu";
                  model.value = "process-defs/flow-model";
                  return model;
                },
              },
            },
            {
              path: "/process-defs/flow-model/create",
              element: <FlowStepExampleV2 />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Thêm quy trình mẫu";
                  model.value = "process-defs/flow-model/create";
                  return model;
                },
              },
            },
            {
              path: "/process-defs/flow-model/edit/:id",
              element: <FlowStepExampleV2Edit />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Sửa quy trình mẫu";
                  model.value = "process-defs/flow-model/create";
                  return model;
                },
              },
            },
            {
              path: "/process-defs/document-model",
              element: <TemplateTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Mẫu tài liệu";
                  model.value = "process-defs/document-model";
                  return model;
                },
              },
            },
          ],
        },
        {
          path: "/partners",
          element: <PartnersView />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Đối tác";
              model.value = "/partners";
              return model;
            },
          },
        },
        {
          path: "/roles",
          element: <RolesView />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Vai trò";
              model.value = "/roles";
              return model;
            },
          },
        },
        {
          path: "/users",
          element: <UserView />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Người dùng";
              model.value = "/users";
              return model;
            },
          },
        },
        {
          path: "/folders-task",
          element: <FoldersTable />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Hồ sơ";
              model.value = "/folders-task";
              return model;
            },
          },
        },
        {
          path: "/approve-task",
          element: <ApproveTable />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Phê duyệt";
              model.value = "/approve-task";
              return model;
            },
          },
        },
        {
          path: "/manager",
          //   element: <SystemView />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Quản trị";
              model.value = "/manager";
              return model;
            },
          },
          children: [
            {
              path: "/manager/users",
              element: <UserTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Tài khoản";
                  model.value = "manager/users";
                  return model;
                },
              },
            },
            {
              path: "/manager/organizations",
              element: <OrganizationsView />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Đơn vị";
                  model.value = "system/organizations";
                  return model;
                },
              },
            },
            {
              path: "/manager/flowchart-operation",
              element: <MainComponent />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Đơn vị";
                  model.value = "system/organizations";
                  return model;
                },
              },
            },
            {
              path: "/manager/roles",
              element: <RolesTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Vai trò";
                  model.value = "manager/roles";
                  return model;
                },
              },
            },
            {
              path: "/manager/partners",
              element: <PartnersTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Đôi tác";
                  model.value = "manager/partners";
                  return model;
                },
              },
            },
          ],
        },
        {
          path: "/method",
          //   element: <SystemView />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Chức năng";
              model.value = "/method";
              return model;
            },
          },
          children: [
            {
              path: "/method/approve-task",
              element: <ListAccessSign />,
              //  element: <ApproveTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Phê duyệt";
                  model.value = "method/approve-task";
                  return model;
                },
              },
            },
            {
              path: "/method/task-for-me",
              element: <ListAccessSignForMe />,
              //  element: <ApproveTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Công việc của tôi";
                  model.value = "method/task-for-me";
                  return model;
                },
              },
            },
            {
              path: "/method/folders-task",
              element: <FoldersTable />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Hồ sơ";
                  model.value = "method/folders-task";
                  return model;
                },
              },
            },
            {
              path: "/method/folders-task-old",
              element: <FoldersTableOld />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Hồ sơ cũ";
                  model.value = "method/folders-task-old";
                  return model;
                },
              },
            },
            {
              path: "/method/folders-edit",
              element: <EditProfile />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Sửa hồ sơ";
                  model.value = "method/folders-task";
                  return model;
                },
              },
            },
            {
              path: "/method/folders-details/:id",
              element: <DetailsProfile />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Xem hồ sơ";
                  model.value = "method/folders-task";
                  return model;
                },
              },
            },
            {
              path: "/method/create-profile",
              element: <CreateProfile />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Tạo hồ sơ";
                  model.value = "method/folders-task";
                  return model;
                },
              },
            },
            {
              path: "/method/add-step/:id",
              element: <FlowStep2 />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Hồ sơ";
                  model.value = "/method/add-step/:id";
                  return model;
                },
              },
            },
            {
              path: "/method/sign-page/:id",
              element: <SignTopage />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Xử lý công việc";
                  model.value = "/method/sign-page/:id";
                  return model;
                },
              },
            },
            {
              path: "/method/view-page/:id",
              element: <ViewTopage />,
              handle: {
                crumb: () => {
                  let model: SelectListItem = {
                    disabled: false,
                    group: null,
                    selected: false,
                    text: "",
                    value: "",
                  };
                  model.text = "Xử lý công việc";
                  model.value = "/method/sign-page/:id";
                  return model;
                },
              },
            },
          ],
        },
      ],
    },
    {
      path: "auth",
      element: <LayoutAuth />, // Define your Auth layout component here
      children: [
        {
          path: "login",
          element: <LayoutLogin />, // Create a Login page component
        },
        // {
        //   path: "register",
        //   element: <Forgetlogin />, // Create a Login page component
        // },
        {
          path: "forget-password",
          element: <Forgetlogin />, // Create a Login page component
        },
        // Add more authentication-related routes here
      ],
    },
    {
      path: "anonymous",
      element: <LayoutAnonymus />, // Define your Auth layout component here
      children: [
        {
          path: "sign-page/:id/user/:user",
          element: <SignTopageAnonymous />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Xử lý công việc";
              model.value = "/method/sign-page/:id";
              return model;
            },
          },
        },

        {
          path: "403",
          element: <PagePersion />,
          handle: {
            crumb: () => {
              let model: SelectListItem = {
                disabled: false,
                group: null,
                selected: false,
                text: "",
                value: "",
              };
              model.text = "Xử lý công việc";
              model.value = "/method/sign-page/:id";
              return model;
            },
          },
        },
        // Add more authentication-related routes here
      ],
    },
  ],
  {
    future: {
      v7_partialHydration: true,
    },
  }
);

export default router;
